import React from "react";
import Slider from "slider";
import _HighlightProductByCategoryContainer from "./_HighlightProductByCategoryContainer.scss";
import Product from "components/partials/product";
import {Products} from "api";
import {Link} from 'react-router-dom';

class HighlightProductByCategoryContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      limit: 10,
      order: "id DESC"
    };
  }

  componentDidMount() {
    let params = {
      filter: {
        limit: this.state.limit,
        order: this.state.order,
        where: {
          isIndustryFeatured: true
        }
      }
    };
    Products.actions.list.request(params).then(response => {
      this.setState({data: response.data});
    });
  }

  render() {
    if (this.state.data.length === 0) {
      return null;
    }
    const settings = {
      className: "slider variable-width product-slick",
      dots: false,
      infinite: false,
      centerMode: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: 651,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 551,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };
    return (
      <section className="center">
        <div className="product-category-container">
          <div className="product-left-content">
            <p className="product-iton">
              <i className="vtd-sp-nong-nghiep"/>
            </p>
            <p className="title-black">Sản phẩm công nghiệp nông thôn tiêu biểu</p>
            <p className="view-more">
              <Link to="/list-products/5a1af1d96c37814cbbb480cd" className="view-more-link">Xem thêm</Link>
            </p>
          </div>
          <div className="product-right-content">
            <Slider {...settings}>
              {this.state.data.map((item, i) => {
                return (
                  <div key={i}>
                    <Product {...item} enableAddProduct={true}/>
                  </div>
                );
              })}
            </Slider>
          </div>
        </div>
      </section>
    );
  }
}

export default HighlightProductByCategoryContainer;



// WEBPACK FOOTER //
// ./components/home/sub-view/HighlightProductByCategoryContainer.jsx